import React, { useEffect, useState } from 'react';
import { Card, Spinner } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import DoctorUsersEditMembership from './DoctorUsersEditMembership';
import DoctorUsersEditExtRef from './DoctorUsersEditExtRef';
import doctorsService from 'services/doctorsService';
import { actionSetEditData } from 'store/actions/usersActions';

/**
 * @component DoctorUsersForm
 * @description Wrapper component for the doctor edition forms.
 * Hydrates the selected user data from the server before rendering
 * the child forms to ensure all relational data (e.g., practices) is available.
 */
const DoctorUsersForm = () => {
  const dispatch = useDispatch();
  const userData = useSelector(state => state.userDoctorsReducer.editData);
  const [loading, setLoading] = useState(true);

  const authUserId = userData?.auth_user_id;
  const hasPractices = Array.isArray(userData?.practices);

  useEffect(() => {
    let isMounted = true;

    const fetchFullProfile = async () => {
      // Skip fetch if no ID is present or if practices are already hydrated
      if (!authUserId || hasPractices) {
        if (isMounted) setLoading(false);
        return;
      }

      try {
        const response = await doctorsService.getDoctorDetails(
          authUserId,
          0,
          50, // Fetch up to 50 associated practices
          0,
          1
        );
        
        const payload = response?.data?.data;
        const resultData = Array.isArray(payload) ? payload[0] : payload?.data?.[0];

        if (isMounted) {
          dispatch(
            actionSetEditData({
              ...userData,
              practices: resultData?.practices || [],
            })
          );
        }
      } catch (error) {
        console.error("Failed to fetch doctor details", error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchFullProfile();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUserId, hasPractices, dispatch]);

  if (loading) {
    return (
      <div 
        className="content user-manual-edit d-flex justify-content-center align-items-center" 
        style={{ minHeight: '50vh' }}
      >
        <Spinner color="info" />
      </div>
    );
  }

  return (
    <div className="content user-manual-edit">
      <Card>
        <DoctorUsersEditMembership />
        <DoctorUsersEditExtRef />
      </Card>
    </div>
  );
};

export default DoctorUsersForm;